<template>
  <div>
    <headerNotice routerName="添加模板"></headerNotice>
    <div class="baseInfo" v-loading="loading">
      <h1>模板信息</h1>
      <div>
        <el-form :model="formData" class="signUp_Form" label-width="250px">
          <el-row>
            <el-col :span="10">
              <el-form-item label="模板名称:">
                <el-input
                  class="inputStyle direct"
                  v-model="formData.name"
                  size="small"
                  placeholder="请输入"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label=" 卡片介绍:">
                <el-input
                  class="inputStyle direct"
                  v-model="formData.introduce"
                  size="small"
                  placeholder="请输入卡片介绍"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <h1>模板图片</h1>
      <div class="goodsBox">
        <el-row>
          <el-col>
            <el-upload
              :accept="accept"
              :headers="headers"
              class="upload-demo"
              :action="uploadAction"
              :on-success="handleGoodsImgstSuccess"
              list-type="picture-card"
              :file-list="goodsImagesList"
              :before-upload="beforeUpload"
              :on-remove="handleGoodsImgstRemove"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
        </el-row>
      </div>
      <h1>卡片</h1>
      <div class="Card">
        <table cellspacing="0">
          <thead>
            <tr>
              <th>名称</th>
              <th>卡片图片</th>
              <th>排序</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in formData.cardList" :key="index">
              <td>
                <input v-model="item.name" type="text" />
              </td>
              <td class="spePic">
                <el-upload
                  :accept="accept"
                  :headers="headers"
                  class="upload-demo"
                  :action="uploadAction"
                  :on-success="handleSpeSuccess"
                  :file-list="item.fileLists"
                  list-type="picture"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :before-upload="beforeUpload"
                >
                  <el-button
                    size="small"
                    type="primary"
                    @click="uploadBtn(index)"
                    >点击上传</el-button
                  >
                </el-upload>
              </td>
              <td>
                <input v-model="item.costPrice" type="number" />
              </td>
              <td>
                <el-button
                  style="margin-top: 20px"
                  type="danger"
                  icon="el-icon-delete"
                  @click="delCard(index)"
                ></el-button>
              </td>
            </tr>
          </tbody>
        </table>
        <el-button type="success" class="addCard" @click="addCard()"
          >新增卡片</el-button>
      </div>
      <!-- 保存 -->
      <div class="saveBox">
        <el-button
          type="primary"
          :loading="btnLoading"
          class="add"
          @click="addTemplateCard()"
          v-if="Id==0"
          >添加模板</el-button
        >
        <el-button
          type="primary"
          :loading="btnLoading"
          class="add"
          >返回</el-button
        >
          <el-button type="success" class="addCard" @click="updateTemplateCard()"     v-if="Id!=0"
          > 修改卡片</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
  data() {
    return {
      formData: {
        truckTemplateID: 0,
        name: "",
        introduce: "",
        explain: "",
        image: [],
        cardList: [
          {
            image: "",
            name: "",
            cardID: 0,
            sort: 0,
          },
        ],
      },
      Id:0,
      loading: false,
      btnLoading: false,
      baseUrl: this.$store.state.URL,
      accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
      uploadAction:
        this.$store.state.apiUrl + "/api/services/app/Image/TxCloudUploadImage", //上传的服务器api地址
      headers: {
        Authorization: localStorage.getItem("accessToken"),
      },
      goodsImagesList: [],
    };
  },
      components: {
        headerNotice
    },
  setup() {},
   created() {
      if (this.$route.query.Id) {
            this.Id = this.$route.query.Id;
             this.getData();
      }   
    },
  mounted() 
  {
   
  }, 
  methods: {
     getData() {
            let self = this;
            //获取
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/TruckTemplate/GetTruckTemplate?truckTemplateID=" + this.Id,
                success(res) {
                    self.formData = res;
                    self.goodsImagesList.push({
                            'name': "",
                            'url': self.baseUrl + self.formData.image
                        })
                    //卡片图片
                    let cardList = res.cardList;
                    cardList.forEach((ele, index) => {
                        cardList[index].fileLists = [
                            {
                                'name': "",
                                'url': self.baseUrl + ele.image
                            }
                        ]
                    })
                    self.loading = false;
                },
                fail(res) {
                    self.cateLoading = false;
                    self.loading = false;
                }
            })
        },
    //相册移除某张
    handleGoodsImgstRemove(file, fileList) {
      let self = this;
      this.goodsImagesList = fileList;
      this.formData.image = [];
      this.goodsImagesList.forEach(function (ele, index) {
        self.formData.image.push(ele.name);
      });
    },
    //相册上传
    handleGoodsImgstSuccess(response, file, fileList) {
      this.formData.image.push(response.result.fileName);
      this.goodsImagesList.push({
        name: response.result.fileName,
        url: this.baseUrl + response.result.url,
      });
    },
    handleExceed() {
      this.$message.error("抱歉，最多上传一张图片！");
    },
    //点击上传按钮 获取该条index
    uploadBtn(index) {
      this.uploadIndex = index;
    },
    //规格上传图片成功事件处理
    handleSpeSuccess(response, file, fileList) {
      debugger
      this.formData.cardList[this.uploadIndex].image =
        response.result.fileName;
    },
    beforeUpload(file) {
      let what = this.$store.state.URL;
      let shif = this.$store.state.apiUrl;
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (file.type != "image/jpeg" && file.type != "image/png") {
        this.$message.error("上传的图片只支持JPG/PNG 的格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
        ///添加
    updateTemplateCard() {
      let self = this;
      this.btnLoading = true;
      self.formData.image=self.formData.image.toString();
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/TruckTemplate/UpdateTruckTemplate",
        data: this.formData,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success",
          });
          self.$router.push({
            path: "/templateList",
          });
          self.btnLoading = false;
        },
        fail(res) {
          self.btnLoading = false;
        },
      });
    },
    ///添加
    addTemplateCard() {
      let self = this;
      this.btnLoading = true;
      self.formData.image=self.formData.image.toString();
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/TruckTemplate/AddTruckTemplate",
        data: this.formData,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success",
          });
          self.$router.push({
            path: "/templateList",
          });
          self.btnLoading = false;
        },
        fail(res) {
          self.btnLoading = false;
        },
      });
    },
    //删除
    delCard(index) {
      this.formData.cardList.splice(index, 1);
    },
    //添加卡片
    addCard() {
      this.formData.cardList.push({
        image: "",
        name: "",
        cardID: 0,
        sort: 0,
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.baseInfo {
  margin: 20px 50px;
  border: 1px solid #c5c5c5;
  h1 {
    background: #f3f3f3;
    padding: 10px 20px;
    span {
      font-size: 12px;
      color: #999;
      i {
        font-style: normal;
      }
    }
  }
}
.Card {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  table {
    width: 100%;
    table-layout: fixed;
    word-break: break-all;
    border: 1px solid #ccc;
    thead {
      width: 100%;
      th {
        height: 50px;
        font-size: 14px;
        color: #666;
        border: 1px solid #ccc;
      }
    }
    tbody tr {
      border: 1px solid #ccc;
      td {
        height: 50px;
        border: 1px solid #ccc;
        vertical-align: middle;
        text-align: center;
        textarea {
          width: 80%;
          appearance: none;
          outline: none;
          border: none;
          min-height: 100px;
          background: #f9f9f9;
          resize: none;
        }
        input {
          text-align: center;
          width: 95%;
          height: 80%;
          outline: none;
          border: none;
          background: #f9f9f9;
        }
        img {
          display: inline-block;
          width: 100px;
          height: 100px;
          cursor: pointer;
        }
        &.spePic {
          padding: 10px;
        }
      }
    }
  }
  .addCard {
    margin: 20px 0;
  }
}
.saveBox {
  border-top: 1px solid #c5c5c5;
  width: 100%;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>